import * as R from 'ramda'

export function isLegacyPlan(plan: unknown): boolean {
  const flag = R.path(['metadata', 'is_new_plan'], plan)
  return String(flag ?? '').toLowerCase() !== 'true'
}

export function isLegacySubscription(subscription: unknown): boolean {
  return (
    isLegacyPlan(R.path(['plan'], subscription)) &&
    R.prop('status', subscription as object) !== 'trialing'
  )
}



// WEBPACK FOOTER //
// ./src/libs/billing/legacy-plan/index.ts